<div class="printable">
  <authority-labs-base-certificate-details
    [order]="order"
    [project]="project"
    [subProject]="subProject"
    [company]="company"
    [contact]="contact"
    [assignee]="assignee"
    [approval]="approval"
    [inspection]="inspection"
    [systemDescription]="'בדיקת משטר הפעלות, מערכת בטיחות אש - אינטגרציה'"
  ></authority-labs-base-certificate-details>

  <div class="page-break"></div>

  <authority-labs-integration-test-results
    [inspection]="inspection.inspectionIntegration"
    [apiUrl]="apiUrl"
  >
  </authority-labs-integration-test-results>

  <authority-labs-certificate-end-line></authority-labs-certificate-end-line>
</div>
